import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=86fb8d48&scoped=true"
import script from "./StatusList.vue?vue&type=script&lang=js"
export * from "./StatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fb8d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86fb8d48')) {
      api.createRecord('86fb8d48', component.options)
    } else {
      api.reload('86fb8d48', component.options)
    }
    module.hot.accept("./StatusList.vue?vue&type=template&id=86fb8d48&scoped=true", function () {
      api.rerender('86fb8d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/StatusList.vue"
export default component.exports